import CancelAssessment from "../../../../assets/images/pre-assessment.svg";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

import Modal from "../../../modal/Modal";

import Button from "../ButtonComponent";

import { BUTTON_VARIANTS } from "../constant";
import { useGetTranslatedText } from "../queries";

import styles from "./styles.module.scss";

const AssessmentExitModal = (props) => {
  const {show , handleContinueAssessment , handleExit} = props;

  const languageId = localStorage.getItem("l_id") || 1;

  const {data:translatedTextResponse} = useGetTranslatedText(languageId)
      
  const {data:translatedText = []} = translatedTextResponse || {};

  return (
    <>
      <Modal visible={show}>
        <div className={styles["feedback-wrapper"]}>
          <div className={styles["success-image"]}>
            <img src={CancelAssessment} alt="success" />
          </div>
          <div className={styles.title}>
            {getTranslatedText(translatedText, "key_exit_learning" , "Exit Assessment?")}
            </div>
          <div className={styles.description}>
            {getTranslatedText(translatedText , "key_continue_assessment" , "You can return anytime to continue Assessment.")}
          </div>

          <div className={styles["button-wrapper"]}>
            <Button
              label={getTranslatedText(translatedText, "label_continue" , "Continue")}
              buttonVariant={BUTTON_VARIANTS.PRIMARY}
              onClick={handleContinueAssessment}
            />
            <Button
              label={getTranslatedText(translatedText , "key_btn_exit" , "Exit")}
              buttonVariant={BUTTON_VARIANTS.SECONDARY}
              onClick={handleExit}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AssessmentExitModal;
